/**
 * Tab icons as inline SVG rather than glyphs or emoji.
 *
 * Emoji would arrive in someone else's colours and break the palette the moment
 * a tab went gold; the Unicode glyphs that exist for these ideas (crossed
 * swords, a crown) render as emoji on most phones anyway. Drawn here, they
 * inherit currentColor and stay a single weight with everything else.
 */

const common = {
  width: 21,
  height: 21,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

/**
 * Play — two crossed swords, each a full weapon: blade from the corner, a
 * crossguard, a grip, and a pommel to finish it.
 *
 * The blades run corner to corner rather than stopping short of the middle,
 * which is what made the first attempt look like two daggers.
 */
export function SwordsIcon() {
  return (
    <svg {...common}>
      {/* tip upper-left, hilt lower-right */}
      <path d="M3.6 2.6 15.8 14.8" />
      <path d="M14.2 18.2 18.2 14.2" />
      <path d="M15.8 14.8 19.2 18.2" />
      <circle cx="20.3" cy="19.3" r="1.25" />
      {/* tip upper-right, hilt lower-left */}
      <path d="M20.4 2.6 8.2 14.8" />
      <path d="M9.8 18.2 5.8 14.2" />
      <path d="M8.2 14.8 4.8 18.2" />
      <circle cx="3.7" cy="19.3" r="1.25" />
    </svg>
  );
}

/** Decks — a card with the stack behind it. */
export function DeckIcon() {
  return (
    <svg {...common}>
      <rect x="9" y="3.5" width="10.5" height="15" rx="2" />
      <path d="M15 20.5H6.5A2 2 0 0 1 4.5 18.5V8" />
    </svg>
  );
}

/** Guild — a crown. */
export function CrownIcon() {
  return (
    <svg {...common}>
      <path d="M4 19.5V8l4.5 3.5L12 4.5l3.5 7L20 8v11.5" />
      <path d="M4 19.5h16" />
    </svg>
  );
}

/** Standings — the rating bars the whole app is built around. */
export function BarsIcon() {
  return (
    <svg {...common}>
      <path d="M4.5 7h15" />
      <path d="M4.5 12h10" />
      <path d="M4.5 17h6" />
    </svg>
  );
}
